import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-plan-name-finsure-field',
  templateUrl: './plan-name-finsure-field.component.html',
  styleUrls: ['./plan-name-finsure-field.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class PlanNameFinsureFieldComponent {
  @Input('lob') lob: any;

  plan_name: any = [];
  @Input('allRuleIdData') allRuleIdData: any;
  form: FormGroup;
  @Input('required') isRequired = false;
  plannameControl = new FormControl();
  lobSelected: any = '';

  constructor(
    private ctrlContainer: FormGroupDirective,
    private http: HttpService
  ) {}

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;
    if (this.form.controls['plan_name']) {
      this.plannameControl.setValue(this.form.controls['plan_name'].value);
    }
    this.form.addControl('plan_name', this.plannameControl);

    this.getPlanName();
  }
  getPlanName() {
    const url = '/services/api/v1/rb_masters/finsure_plan_name';
    this.http.get(url).subscribe((res: any) => {      
      this.plan_name = res['data'];
      if (this.form.value['plan_name_edit']) {
        this.plannameControl.setValue(this.form.value['plan_name_edit']);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lob']) {      
      if (changes['lob'].currentValue !== '') {
        this.lobSelected = changes['lob'].currentValue;
      }
    }
  }

  ngOnDestroy(): void {
    this.form.removeControl('plan_name');
  }
}
